import React from 'react';

import { Box, Spinner } from '@rbilabs/universal-components';
import { StoreChangeDisclaimer } from 'features/store/pages/store-locator-experiment/components';
import { useIntl } from 'react-intl';

import ActionButton from 'components/action-button';
import { primitive } from 'styles/constants/primitives';

import { DeliveryTerms } from '../delivery-terms';

import { ButtonContainer, DeliveryInfoContainer, LoadingText } from './styled';

interface IDeliveryFormFooterProps {
  submitAddress: () => void;
  isDisabled: boolean;
  isLoading: boolean;
  isEditing?: boolean;
  showtermsLink?: boolean;
  setShowTermsView?: (show: boolean) => void;
}

export const DeliveryAddressFormFooter: React.FC<React.PropsWithChildren<
  IDeliveryFormFooterProps
>> = ({ submitAddress, isDisabled, isLoading, isEditing, showtermsLink, setShowTermsView }) => {
  const { formatMessage } = useIntl();

  return (
    <>
      {!showtermsLink ? (
        <ButtonContainer>
          <ActionButton
            onPress={submitAddress}
            fullWidth
            color={primitive.bk.$white}
            mb="$4"
            disabled={isLoading || isDisabled}
            _disabled={{
              bg: primitive.bk.$fieryRedOpacity30,
              color: primitive.bk.$white,
              opacity: 1,
              borderWidth: 0,
            }}
            isLoading={isLoading}
            testID="deliver-here"
            rightIcon={
              isLoading ? (
                <Box width="$4" height="$4" justifyContent="center" alignItems="center">
                  <Spinner size="sm" color={primitive.bk.$white} />
                </Box>
              ) : undefined
            }
            _text={{
              fontSize: 'lg',
              color: isLoading ? primitive.bk.$bbqBrown : primitive.bk.$white,
            }}
            _loading={{
              bg: primitive.bk.$fieryRedOpacity30,
              borderWidth: 0,
              borderColor: primitive.bk.$bbqBrown,
            }}
          >
            {isEditing
              ? formatMessage({ id: 'upateAddress', defaultMessage: 'Update Address' })
              : formatMessage({ id: 'deliverHere' })}
          </ActionButton>
        </ButtonContainer>
      ) : (
        <DeliveryInfoContainer>
          <DeliveryTerms onOpenTerms={() => setShowTermsView && setShowTermsView(true)} />
          <StoreChangeDisclaimer />
        </DeliveryInfoContainer>
      )}
      {!isEditing && isLoading && (
        <Box>
          <LoadingText>{formatMessage({ id: 'deliveryCheckingMessage' })}</LoadingText>
        </Box>
      )}
    </>
  );
};
